import { PropsWithChildren, useContext, useState } from 'react'
import {
  UninstallAppBySupplierContext,
  UninstallBySupplierContextProps
} from '@/modules/utilities/uninstallApp/provider/UninstallAppBySupplierContext.ts'

export const UninstallAppBySupplierProvider = ({
  children
}: PropsWithChildren) => {
  const [articleData, setArticleData] = useState<
    UninstallBySupplierContextProps['articleData']
  >({
    brandId: '',
    brandName: '',
    supplier: null
  })

  return (
    <UninstallAppBySupplierContext.Provider
      value={{ articleData, setArticleData }}
    >
      {children}
    </UninstallAppBySupplierContext.Provider>
  )
}

export const useUninstallBySupplierContext = () => {
  const context = useContext(UninstallAppBySupplierContext)
  if (context === null) {
    throw new Error(
      'useUninstallBySupplierContext must be used within a UninstallAppBySupplierProvider'
    )
  }
  return context
}
